import React from 'react';

import styled from '@emotion/styled';
import { useMediaQuery } from '@react-hook/media-query';

import ArrowIcon from '../Icons/ArrowIcon';
import DangerIcon from '../Icons/DangerIcon';
import { IButton } from './interface';

export const PrimaryButton: React.FC<IButton> = ({
  children,
  className,
  arrowIcon,
}) => {
  const isMobile = useMediaQuery('(max-width: 480px)');
  return (
    <StyledButton className={className ? className : ''}>
      {children} {arrowIcon && !isMobile && <ArrowIcon />}{' '}
      {className?.includes('danger') && <DangerIcon />}
    </StyledButton>
  );
};

const StyledButton = styled.button`
  display: flex;
  gap: 1.25rem;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.palette.mainBlue};
  color: ${({ theme }) => theme.palette.mainBlue};
  text-align: center;
  border-radius: 0.375rem;
  padding: 0.5rem 1.5rem;
  background-color: transparent;
  cursor: pointer;
  font-weight: 400;

  &.grey {
    border: 1px solid ${({ theme }) => theme.palette.greyGrey1};
    color: ${({ theme }) => theme.palette.greyGrey1};
  }

  &.big {
    padding: 1.25rem;
    font-size: 1.25rem;
    font-weight: 600;
    @media (max-width: 480px) {
      display: block;
      // padding: .5rem 5rem;
      width: 100%;
      padding: 0.5rem 0;
      font-size: 2rem;
      margin-top: 0rem;
    }
  }

  &.bigg {
    padding: 0.5rem 1rem;
    font-weight: 600;
    background-color: #2857d1;
    color: white;
    border: none;
  }

  &.bigg1 {
    padding: 0.5rem 5rem;
    font-weight: 600;
    background-color: #7a40f2f2;
    border: none;
    color: white;
  }

  &.edit {
    padding: 0.1rem 2rem;
    border-radius: 2px;
    border: 1px solid #000;
    color: black;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
  }

  &.delete {
    padding: 0.1rem 2rem;
    border-radius: 2px;
    border: 1px solid #e01d1d;
    color: #e01d1d;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
  }

  &.smallGap {
    gap: 0.5rem;
    @media (max-width: 480px) {
      display: flex;
      padding: 0.8rem 9.7rem;
      font-size: 20px;
      font-weight: 600;
      margin-top: 0rem;
    }
  }

  &.contentFit {
    width: fit-content;
  }

  &.transparent {
    padding: 0.94rem 3.62rem;
    background-color: transparent;
    border-color: white;
    color: white;
    border-radius: 0.1875rem;

    @media (max-width: 480px) {
      display: block;
      // padding: .2rem 7rem;
      font-size: 1.3rem;
      width: 100%;
      margin-top: 0rem;
    }
  }

  &.weight500 {
    font-weight: 500;
    padding: 0.94rem 5.5rem;

    @media (max-width: 480px) {
      padding: 1rem 5rem;
      font-size: 0.8rem;
      font-weight: 700;
      width: 100%;
      margin-bottom: -1rem;
    }
  }

  &.noBorder {
    border: 1px solid transparent;
    padding: 0;
    font-size: 1.125rem;
    font-weight: 500;
  }

  &.fw600 {
    font-weight: 600;
  }

  &.pl-pr-4 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  &.danger {
    border: 1px solid ${({ theme }) => theme.palette.stateColorRed};
    color: ${({ theme }) => theme.palette.stateColorRed};
  }
`;
